class ThemeSwiperBreakpoint extends HTMLElement {
  options = {}; width; swiper; isConnected = false;

  constructor() {
    super();
  }

  init = () => {
    this.options = {};
    this.width = parseInt(this.dataset.breakpoint);
    this.setSlides(this.dataset.slides);
    this.setSpaceBetween(this.dataset.spaceBetween);
    this.setSlideGroups(this.dataset.slideGroups);
    this.swiper = this.closest('theme-swiper');
  
    const breakpoints = Array.from(this.swiper.querySelectorAll('theme-swiper-breakpoint'));
    const allConnected = breakpoints.every(breakpoint => breakpoint.isConnected);
  
    if (allConnected) {
      this.swiper.init();
    }
  }

  connectedCallback() {
    this.isConnected = true;
    this.init();
  }

  getPointOptions = () => {
    return this.options;
  }

  setSpaceBetween = (spaceBetween) => {
    const s = parseInt(spaceBetween);
    if(!isNaN(s)){
      this.options.spaceBetween = s;
    }
  }  

  setSlideGroups = (slideGroups) => {
    const s = parseInt(slideGroups);
    if(!isNaN(s)){
      this.options.slidesPerGroup = s;
    }
  }  

  setSlides = (slides) => {
    if(slides != undefined){
      this.options.slidesPerView = slides;
    }
  } 
}
class ThemeSwiper extends HTMLElement {
  options; swiper;
  paginationSelector = '.swiper-pagination';
  navigationPrev = '.swiper-button-prev';
  navigationNext = '.swiper-button-next';
  scrollbarSelector = '.swiper-scrollbar';

  constructor() {
    super();
  }

  connectedCallback() {
    if(this.find != undefined){
      this.swiper.destroy();
    }
    const breakpoints = this.querySelectorAll('theme-swiper-breakpoint');
    if(breakpoints.length <= 0){
      if(this.dataset.noinit === undefined || this.dataset.noinit === 'false')
        this.init();
    }
  }

  init = () => {
    this.options = { };
    this.paginationSelector = this.dataset.paginationSelector || this.paginationSelector;
    this.navigationPrev = this.dataset.navigationPrev || this.navigationPrev;
    this.navigationNext = this.dataset.navigationNext || this.navigationNext;
    this.scrollbarSelector = this.dataset.scrollbarSelector || this.scrollbarSelector;

    this.setNavigation(this.dataset.navigation !== undefined && this.dataset.navigation !== 'false');
    this.setPagination(this.dataset.pagination !== undefined && this.dataset.pagination !== 'false');
    this.setDynamicBullets(this.dataset.dynamicBullets !== undefined && this.dataset.dynamicBullets !== 'false');
    this.setPaginationType(this.dataset.paginationType);
    this.setPaginationCustom(this.dataset.paginationCustom);
    this.setScrollbar(this.dataset.scrollbar !== undefined && this.dataset.scrollbar !== 'false');
    this.setMousewheel(this.dataset.mousewheel !== undefined && this.dataset.mousewheel !== 'false');
    this.setScrollbarHide(this.dataset.scrollbarHide !== undefined && this.dataset.scrollbarHide !== 'false');
    this.setDirection(this.dataset.direction);
    this.setSpaceBetween(this.dataset.spaceBetween);
    this.setSlides(this.dataset.slides);
    this.setCentered(this.dataset.centered !== undefined && this.dataset.centered !== 'false');
    this.setFree(this.dataset.free !== undefined && this.dataset.free !== 'false');
    this.setLoop(this.dataset.loop !== undefined && this.dataset.loop !== 'false');
    this.setAutoplay(this.dataset.autoplay);
    this.setWatchProgress(this.dataset.watchProgress !== undefined && this.dataset.watchProgress !== 'false');
    this.setThumbs(this.dataset.thumbs);
    this.setSlideGroups(this.dataset.slideGroups);
    this.setBreakpoints();
    this.swiper = new Swiper(this, this.options);  

    console.log(this.options);
  }

  setOptions = (options) => {
    this.options = options;
    this.swiper = new Swiper(this, this.options);
  }

  setSlideGroups = (slideGroups) => {
    const s = parseInt(slideGroups);
    if(!isNaN(s)){
      this.options.slidesPerGroup = s;
    }
  }  

  setNavigation = (navigation) => {
    if(navigation) {
      this.options.navigation = {
        nextEl: this.navigationNext,
        prevEl: this.navigationPrev
      }
    } 
  }

  setPagination = (pagination) => {
    if(pagination) {
      this.options.pagination = {
        el: this.paginationSelector,
        clickable: true
      }
    } 
  }

  setDynamicBullets = (dynamicBullets) => {
    if(dynamicBullets) {
      this.options.pagination = this.options.pagination || {};
      this.options.pagination.dynamicBullets = true;
    } 
  }

  setPaginationType = (type) => {
    if(type != undefined){
      this.options.pagination = this.options.pagination || {};
      this.options.pagination.type = type;
    }
  }  

  setPaginationCustom = (custom) => {
    if(custom != undefined){
      this.options.pagination = this.options.pagination || {};
      const parts = custom.split(',');
      this.options.pagination.renderBullet = (i, c) => {
        return `<span class="${c}">${parts[i]}</span>`;
      } ;
    }
  }

  setScrollbar = (scrollbar) => {
    if(scrollbar) {
      this.options.scrollbar = {
        el: this.scrollbarSelector,
        draggable: true
      }
    } 
  }

  setScrollbarHide = (hide) => {
    if(hide) {
      this.options.scrollbar = this.options.scrollbar || {};
      this.options.scrollbar.hide = true;
    } 
  }

  setDirection = (direction) => {
    if(direction != undefined){
      this.options.direction = direction;
    }
  }  

  setSpaceBetween = (spaceBetween) => {
    const s = parseInt(spaceBetween);
    if(!isNaN(s)){
      this.options.spaceBetween = s;
    }
  }  

  setSlides = (slides) => {
    if(slides != undefined){
      this.options.slidesPerView = slides;
    }
  } 

  setCentered = (centered) => {
    if(centered) {
      this.options.centeredSlides = true;
    } 
  }

  setMousewheel = (mousewheel) => {
    if(mousewheel) {
      this.options.mousewheel = true;
    } 
  }

  setFree = (free) => {
    if(free) {
      this.options.freeMode = true;
    } 
  }

  setLoop = (loop) => {
    if(loop) {
      this.options.loop = true;
    } 
  }

  setAutoplay = (autoplay) => {
    const s = parseInt(autoplay);
    if(!isNaN(s)){
      this.options.autoplay = {
        delay: s
      };
    }
  }  

  setWatchProgress = (watchProgress) => {
    if(watchProgress) {
      this.options.watchSlidesProgress = true;
    } 
  }

  setThumbs = (selector) => {
    const thumbs = document.querySelector(selector);
    if(thumbs != undefined && thumbs != null){
      this.options.thumbs = {
        swiper: thumbs
      };
    }
  } 

  setBreakpoints = () => {
    const breakpoints = this.querySelectorAll('theme-swiper-breakpoint');
    if(breakpoints.length > 0){
      var notFound = false;
      this.options.breakpoints = {};
      breakpoints.forEach(breakpoint => {
        if (typeof breakpoint.getPointOptions === 'function') {
          this.options.breakpoints[breakpoint.width] = breakpoint.getPointOptions();
        } else {
          notFound = true;
        }
      });
    }
  }

}
if (!window.customElements.get("theme-swiper")) {
  window.customElements.define("theme-swiper", ThemeSwiper);
}
if (!window.customElements.get("theme-swiper-breakpoint")) {
  window.customElements.define("theme-swiper-breakpoint", ThemeSwiperBreakpoint);
}
